<template>
  <div class="share">
    <span class="share__label">
      Spread the word
    </span>
    <div class="share__list">
      <social-sharing inline-template :url="this.overviewUrl" twitter-user="ICIJorg" title="Explore: Welcome to Mauritius, Africa’s popular offshore tax hub. #ParadisePapers">
        <span>
          <span class="share__list__item">
            <network class="share__list__item__link" network="twitter">
              <span class="sr-only">On Twitter</span>
              <i class="fa fa-twitter" title="Share on Twitter"></i>
            </network>
          </span>
        </span>
      </social-sharing>
      <social-sharing inline-template :url="this.overviewUrl" title="Explore: See how companies are slashing their taxes in Africa" description="Discover the tax agreements helping companies investing in Africa slash their tax bill.">
        <span>
          <span class="share__list__item">
            <network  class="share__list__item__link" network="facebook">
              <span class="sr-only">On Facebook</span>
              <i class="fa fa-facebook" title="Share on Facebook"></i>
            </network>
          </span>
          <span class="share__list__item">
            <network  class="share__list__item__link" network="linkedin">
              <span class="sr-only">On Linkedin</span>
              <i class="fa fa-linkedin" title="Share on Linkedin"></i>
            </network>
          </span>
        </span>
      </social-sharing>
      <span class="share__list__item">
        <a @click="showEmbed"  class="share__list__item__link" tabindex>
          <span class="sr-only">Embed</span>
          <i class="fa fa-code" title="Embed on your website"></i>
        </a>
      </span>
    </div>
  </div>
</template>

<style lang="scss">
  body .v--modal-overlay {
    z-index: $zindex-sticky + 10;
  }

  .share {
    padding: 0.5em 0;
    text-align: center;
    border-color: theme-color("warning");
    font-family: $headings-font-family;
    font-weight: bolder;
    text-transform: uppercase;

    &__label {
      color: inherit;
      padding-right: $spacer * 2/3;
    }

    &__list {
      display: inline-block;
      margin:0;
      margin-top: 0.5em;
      white-space: nowrap;
      font-weight: normal;

      &__item a.share__list__item__link,
      &__item .share__list__item__link {
        padding:0 $spacer * 2/3;
        position: relative;
        display: inline-block;
        color: theme-color("warning");
        border-color: inherit;
        cursor: pointer;

        &:hover {
          color: $link-hover-color;
          border-color: $link-hover-color;
        }

        &:before {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          width: 2em;
          height: 2em;
          border: 1px solid;
          border-color: inherit;
          border-radius: 1em;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
</style>

<script>
import SocialSharing from 'vue-social-sharing'
import Vue from 'vue'

Vue.use(SocialSharing)

export default {
  methods: {
    showEmbed () {
      // This modal must be created somewhere in the parent components
      this.$modal.show('embed-form')
    }
  },
  components: {
    SocialSharing
  },
  computed: {
    host () {
      const protocol = window.location.protocol
      const slashes = protocol.concat('//')
      return slashes.concat(window.location.host)
    },
    overviewUrl () {
      const route = this.$router.resolve({ name: 'overview' })
      return [this.host, window.location.pathname, route.href].join('')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Share.vue?431dcf52